








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TextArea extends Vue {
  /** Value is a tuple of the shape (text, hasError).
   * If `hasError` is set, the TextArea is highlighted.
   */
  @Prop() value!: {
    text: string;
    hasError: boolean;
  };
  @Prop() name!: string;

  private changeValue(value: string) {
    this.$emit('input', { text: value, hasError: this.value.hasError });
  }
}
